import { Rule } from 'antd/es/form';
import {
    createMaxLengthRule,
    createMaxLengthRuleOptional,
    createMinLengthRule,
} from 'utils/formValidationHelpers';

// Updated text rules using the new validation system
export const max300LengthRule: Rule = createMaxLengthRule(300);
export const max300LengthRuleOptional: Rule = createMaxLengthRuleOptional(300);
export const max2000LengthRule: Rule = createMaxLengthRule(2000);
export const max3000LengthRule: Rule = createMaxLengthRule(3000);
export const max5000LengthRule: Rule = createMaxLengthRule(5000);
export const min2LengthRule: Rule = createMinLengthRule(2);
